@if (hasActiveConnection$ | async) {
    <adapt-dashboard-element name="Teams">
        <ng-container *adaptLoadingUntilFirstEmit="let teams of teams$">
            @for (team of teams; track team.teamId) {
                @let roles = teamRoles.get(team);
        <div class="d-flex flex-row align-items-center gap-1">
            <adapt-link-team [team]="team" [focusPersonId]="(person$ | async)?.personId"></adapt-link-team>
            @if (roles?.length) {
                    <button adaptTooltip="Show roles pinned to the team that this person is assigned to"
                            class="py-0"
                            [(adaptCollapsibleButton)]="teamCollapseStates![team.teamId]"></button>
                }
                </div>
                @if (roles) {
                    <div [collapse]="teamCollapseStates![team.teamId]"
                         [isAnimated]="true">
                        <div class="border-0 border-3 border-start ps-2 ms-1">
                            @for (role of roles; track role.roleId) {
                                <div>
                                    <adapt-link-role [role]="role"></adapt-link-role>
                                </div>
                            }
                        </div>
                    </div>
                }
            } @empty {
                This person is not a member of any team
            }
        </ng-container>
    </adapt-dashboard-element>
}
